/*global angular */

(function () {
    'use strict';

    angular.module('sky.reorder', ['sky.reorder.component']);
}());
